export default "__VITE_ASSET__D8rrFZb2__"